/**
 * FREE SIGNUP TESTING WINDOW
 * Payment is bypassed until FREE_UNTIL. After that, PayFast R92 gate is restored automatically.
 * Set at: 2026-07-15 18:45:18 UTC  |  Expires: 2026-07-16 09:45:18 UTC (15 hours)
 */
export const FREE_UNTIL = new Date('2026-07-16T09:45:18.000Z');

/** Returns true if we are still within the free testing window */
export function isInFreeWindow(): boolean {
  return new Date() < FREE_UNTIL;
}
